import { FormMutationInterface } from "../../../../../kernel/form/interfaces/form-mutation.interface";

export const updateStockTypeConfig: () => FormMutationInterface = () => ({
  name: "updateStockType",
  paramName: "stockType",
  paramType: "StockTypeInput",
  extraParams: { id: "ID!" },
  select: ["id"],
});
